import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter, useLocation } from 'react-router-dom'
import { AuthProvider } from '@/contexts/AuthContext'
import { AppRoutes } from '@/routes'
import { Header } from '@/components/Header'
import { Footer } from '@/components/Footer'
import { Toaster } from '@/components/ui/toaster'
import { ErrorBoundary } from '@/components/error'
import { NetworkErrorBoundary } from '@/components/error'
import '@/styles/globals.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
})

function AppContent() {
  const location = useLocation()

  // Embed routes (e.g. /series/:id/graph) render bare — no shell, no header, no footer.
  const isEmbedRoute = /\/graph$/.test(location.pathname)
  if (isEmbedRoute) {
    return <AppRoutes />
  }

  const showHeader = location.pathname !== '/'

  return (
    <>
      <div className="flex min-h-screen flex-col">
        {showHeader && <Header />}
        <main className="flex-1">
          <AppRoutes />
        </main>
        <Footer />
      </div>
      <Toaster />
    </>
  )
}

function App() {
  return (
    <ErrorBoundary level="app">
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthProvider>
            <NetworkErrorBoundary>
              <AppContent />
            </NetworkErrorBoundary>
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  )
}

export default App
